import {
  getAction,
  deleteAction,
  putAction,
  postAction,
  downFile
} from '@/api/manage'

import { baseURL } from '@/utils/network'

// 新增一级地块
const addManor = (params) => postAction('/api/manor', params)
// 获取一级地块
const getManor = (params) => getAction('/api/manor', params)
// 修改一级地块
const updateManor = (params) => putAction('/api/manor', params)
// 删除一级地块 
const deleteManor = (params) => deleteAction('/api/manor', params)
// 导出一级地块
const exportManor = () => downFile('/api/manor/download')
// 添加vr
const addVr = (params) => postAction('/api/vr', params)
// 查询vr
const getVr = (params) => getAction('/api/vr', params)
// 修改vr
const updateVr = (params) => putAction('/api/vr', params)

// 新增二级地块
const addSecondArea = (params) => postAction('/api/secondArea', params)
// 获取二级地块
const getSecondArea = (params) => getAction('/api/secondArea', params)
// 修改二级地块
const updateSecondArea = (params) => putAction('/api/secondArea', params)
// 删除二级地块 
const deleteSecondArea = (params) => deleteAction('/api/secondArea', params)

// 新增三级地块
const addThreeArea = (params) => postAction('/api/threeArea', params)
// 获取三级地块
const getThreeArea = (params) => getAction('/api/threeArea', params)
// 修改三级地块
const updateThreeArea = (params) => putAction('/api/threeArea', params)
// 删除三级地块 
const deleteThreeArea = (params) => deleteAction('/api/threeArea', params)

// 新增四级地块
const addFourArea = (params) => postAction('/api/fourArea', params)
// 获取四级地块
const getFourArea = (params) => getAction('/api/fourArea', params)
// 修改四级地块
const updateFourArea = (params) => putAction('/api/fourArea', params)
// 删除四级地块 
const deleteFourArea = (params) => deleteAction('/api/fourArea', params)

// 查询未绑定地块
const unBindArea = (params) => getAction('/api/vrHotSpots/unBindArea', params)
// 新增热点
const addVrHotSpots = (params) => postAction('/api/vrHotSpots', params)
// 获取热点
const getVrHotSpots = (params) => getAction('/api/vrHotSpots', params)
// 修改热点
const updateVrHotSpots = (params) => putAction('/api/vrHotSpots', params)
// 删除热点
const deleteVrHotSpots = (params) => deleteAction('/api/vrHotSpots', params)



// 文件上传
const uploadUrl = baseURL + 'api/localStorage'
// 文件上传2  typeId   type
const uploadUrl2 = baseURL + 'api/localStorage/uploadByType'

export default {
  addManor,
  getManor,
  updateManor,
  deleteManor,
  exportManor,
  addVr,
  getVr,
  updateVr,
  addSecondArea,
  getSecondArea,
  updateSecondArea,
  deleteSecondArea,
  addThreeArea,
  getThreeArea,
  updateThreeArea,
  deleteThreeArea,
  addFourArea,
  getFourArea,
  updateFourArea,
  deleteFourArea,
  unBindArea,
  addVrHotSpots,
  getVrHotSpots,
  updateVrHotSpots,
  deleteVrHotSpots,
  uploadUrl,
  uploadUrl2
}


// WEBPACK FOOTER //
// ./src/api/api.js